import { Dropdown } from "bootstrap";
const cardUsers = {
  props: {
    user: Object,
    action: Function,
    pretenom: Boolean,
    gere: Boolean, 
	gouserpage:Function
  },

  data: function () {
    return {
      hover: false,
    };
  },

  template: `
	<div>
		<div class="card pb-0 m-0">
			<div class="dropdown card-dropdown pt-2 mt-2" v-if="pretenom">
				<a
					href="#"
					ref="el"
					class="dropdown-ellipses dropdown-toggle"
					data-bs-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
				>
					<i class="fe fe-more-vertical"></i>
				</a>

				<div class="dropdown-menu dropdown-menu-end">
					<span
						v-if="pretenom"
						class="dropdown-item main"
						:pretenom="pretenom"
						@click="$emit('connectas')"
						>Connect as</span
					>
					<span
						v-if="gere && user.status==='D'"
						class="dropdown-item main"
						@click="$emit('enable')"
						>Enable</span
					>
					<span
						v-if="gere && user.status!=='D'"
						class="dropdown-item main"
						@click="$emit('disable')"
						>Disable</span
					>
					<span v-if="gouserpage!==null"
 						class="dropdown-item main"
						@click="$emit('gouserpage')"
						>View user</span
					>
				</div>
			</div>
			<div class="card-body">
				<div class="row align-items-center">
					<div class="col-auto text-center">
						<div class="avatar avatar-md">
							<span
								class="avatar-title rounded-circle"
								:class="(user.profil)? 'bg-'+user.profil:'bg-light-secondary' "
							>
								{{ user.initial }}
							</span>
						</div>
					</div>

					<div class="col ms-n2">
						<h4 class="my-1">
							<div class="row">
								<div class="col-auto pt-1 mt-">
									{{ user.displayname || user.k }}
									<span class="text-muted mx-2">&bull;</span>
									{{user.title || user.profilV || user.profil }}
								</div>
							</div>
						</h4>
						<p class="small m-0 mt-n1">
							<span>{{ user.email }}</span>
						</p>
						<p class="m-0">
							<span
								v-if="gere && user.status !=='D'"
								class="badge bg-success-soft"
								>Enable</span
							>
							<span v-if="gere && user.status ==='D'" class="badge bg-danger-soft"
								>Disable</span
							>
						</p>
						<p
							class="small m-0"
							v-show="user.groups && user.groups.length>0"
							v-for="group in user.groups"
						>
							<small class="badge bg-light fs-6 me-1">{{user.group }}</small>
						</p>
					</div>

					<div class="col-auto ms-n2">
						<slot></slot>
					</div>
				</div>
			</div>
		</div>
	</div>
	`,
};

export default cardUsers;
